import React from 'react';
import type { CoreContextProps } from './config.context';
import { CoreConfigContext } from './config.context';

export const CoreConfigProvider: React.FC<CoreContextProps> = props => {
  return (
    <CoreConfigContext.Provider
      value={{
        ...props,
      }}
    >
      {props.children}
    </CoreConfigContext.Provider>
  );
};
